import React from 'react';
import { supabase } from '../lib/supabase';
import { format } from 'date-fns';

const TYPE_CONFIG = {
  kith: { label: 'Custom Kith', color: 'text-theme-moss', bg: 'bg-theme-moss/10', border: 'border-l-theme-moss' },
  place: { label: 'Place', color: 'text-theme-slate', bg: 'bg-theme-slate/10', border: 'border-l-theme-slate' },
  session: { label: 'Journey Note', color: 'text-theme-honey', bg: 'bg-theme-honey/10', border: 'border-l-theme-honey' },
  rule: { label: 'House Rule', color: 'text-theme-rose', bg: 'bg-theme-rose/10', border: 'border-l-theme-rose' },
};

export default function EntryCard({ entry, onEdit, onRefresh }) {
  const config = TYPE_CONFIG[entry.type] || TYPE_CONFIG.kith;
  const natures = entry.natures ? entry.natures.split('\n').filter(Boolean) : [];

  const handleDelete = async () => {
    if (window.confirm('Remove this entry?')) {
      await supabase.from('entries').delete().eq('id', entry.id);
      onRefresh?.();
    }
  };

  return (
    <div className={`bg-parchment-mid border-[1.5px] border-parchment-dark border-l-[3px] ${config.border} rounded p-5 pt-6 pb-4 relative shadow-card transition-all hover:-translate-y-[2px] hover:rotate-[0.25deg] hover:shadow-card-hover flex flex-col`}>
      <div className="card-tape"></div>
      
      <div className="mb-2">
        <span className={`inline-block font-lora text-[0.8rem] px-2.5 py-0.5 rounded-full ${config.bg} ${config.color}`}>
          {config.label}
        </span>
      </div>

      <div className="font-playfair text-lg font-bold text-ink mb-1 leading-snug">{entry.name}</div>
      {entry.region && <div className="font-lora text-[0.78rem] italic text-ink-mid mb-1.5">{entry.region}</div>}
      {entry.players && <div className="font-lora text-[0.78rem] italic text-ink-mid mb-1.5">Players: {entry.players}</div>}
      {entry.trigger && <div className="font-lora text-[0.78rem] italic text-ink-mid mb-1.5">When: {entry.trigger}</div>}

      <div className="flex-grow mt-2">
        {natures.length > 0 && (
          <div className="font-lora text-[0.82rem] text-ink-mid leading-relaxed mb-2">
            {natures.map((n, i) => <div key={i}>✦ {n.trim()}</div>)}
          </div>
        )}
        {entry.notes && (
          <div className="font-lora text-[0.82rem] text-ink-mid leading-relaxed whitespace-pre-wrap mt-1">
            {entry.notes}
          </div>
        )}
      </div>

      <div className="flex justify-between items-center mt-4 pt-3 border-t border-dashed border-parchment-dark">
        <span className="font-lora text-[0.76rem] text-ink-light">
          {format(new Date(entry.created_at), 'MMM d, yyyy')}
        </span>
        <div className="flex gap-2 items-center">
          <button onClick={onEdit} className="bg-transparent border border-parchment-dark rounded px-2.5 py-0.5 font-lora text-[0.76rem] text-ink-mid cursor-pointer transition-colors hover:bg-ink hover:text-parchment hover:border-ink">
            edit
          </button>
          <button onClick={handleDelete} className="bg-transparent border-none text-theme-roseLight cursor-pointer text-[0.76rem] font-lora opacity-50 transition-opacity hover:opacity-100">
            remove
          </button>
        </div>
      </div>
    </div>
  );
}